import { createFileRoute } from '@tanstack/react-router';
import { parseViewPageSearch } from '../../views/model/view-state.js';
import { ViewPage } from '../../views/ViewPage.js';

export const Route = createFileRoute('/views/$viewId')({
  validateSearch: parseViewPageSearch,
  component: ViewRoute,
});

function ViewRoute(): React.JSX.Element {
  const { viewId } = Route.useParams();
  const search = Route.useSearch();
  const { me } = Route.useRouteContext();
  return <ViewPage viewId={viewId} me={me} search={search} />;
}
